import type { ReactNode } from 'react'
import { Breadcrumb, type BreadcrumbItem } from '@/components/Breadcrumb'
import styles from './CallCenter.module.css'

export interface CallCenterProps {
  breadcrumbItems: BreadcrumbItem[]
  /**
   * The active section.
   */
  children?: ReactNode
  dialogs?: ReactNode
}

export function CallCenter({
  breadcrumbItems,
  children,
  dialogs,
}: CallCenterProps) {
  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <div className={styles.title}>Call center</div>
        <Breadcrumb items={breadcrumbItems} />
      </header>
      <div className={styles.headerSeparator} />

      {children}

      {dialogs}
    </div>
  )
}
